
import React, { Component } from 'react';
import AdmissionApi from '../../Services/AdmissionApi';
import './style.css';
import { toast } from 'react-toastify'
import moment from 'moment'

class OtpForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      otp: '',
      db_otp: '',
      phone: '',
      id: 'signin-link',
      errors: {},
      check: false,
      isSubmitting: false,          
      showVerificationUI: false, 
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);

    this.admissionsService = new AdmissionApi();
  }

  handleChange(evt) {
    if (this.state.check) {
      this.handleValidation();
    }
    this.setState({ [evt.target.name]: evt.target.value });
  }

  sendOtp = (res) => {
    // send OTP on SMS
    const data = res.data.attributes

    const propData = this.props.data

    propData.userId = data.id
    propData.school_code=data.school_code
    propData.fName = data.first_name
    propData.lName = data.last_name
    propData.email = data.email
    propData.gender = data.gender
    propData.date_of_birth = moment(data.date_of_birth).format('YYYY-MM-DD')
    propData.subjects = data.subjects
    propData.father_name = data.father_name
    propData.phone = data.phone
    
    let smsData = {
      dest_mobileno: data.phone,
      message: `Use ${data.otp} as one-time password (OTP) for creating an account on NOTIFYi. Valid for 15 minutes. This can be used only once\n\nThanks\nTeam Notifyi`
    }
    this.admissionsService.sendSms(() => {
    }, smsData)

    // Send OTP on Email
    let mailobj = {
      action: "send_otp",
      mail_data: {
        otp: data.otp,
        user_name: data.first_name + " " + data.last_name,
      },
      address: {
        to: data.email,
        name: data.first_name + " " + data.last_name,
      },
    };
  
    this.admissionsService.sendMail(
      console.log,
      mailobj,
      "settings/v1/mail/send"
    );
  }

  getOtp = () => {
    let obj = {
      email: this.props.data.email,
    };
    this.admissionsService.createNew(
      this.sendOtp,
      obj,
      "v1/users/resend-otp"
    );
  }

  handlePostVerification = (res) => {
    const {
      userId,
      school_code,
      fName,
      lName,
      email,
      gender,
      date_of_birth,
      subjects,
      father_name,
      phone,
      approval_status
    } = this.props.data

    console.log(this.props.data,"from props")



    let _obj = {
      user_id: userId,
      school_code: school_code,
      first_name: fName,
      last_name: lName,
      email: email,
      gender: gender,
      date_of_birth: date_of_birth,
      phone_number: phone,
      subjects: subjects,
      father_name: father_name,
      active: 1,
      approval_status
    };

    this.admissionsService.createNew(() => {
      localStorage.setItem('isLogin', "1");
      this.setState({ isSubmitting: false }); 
      this.props.proceedLogin();
    }, _obj, "v1/students");
  }

  handleLogin(e) {
    e.preventDefault()
    this.setState({ check: true });
    if (this.handleValidation()) {
      this.setState({ isSubmitting: true });
      const payload = {
        email: this.props.data.email,
        otp: this.state.otp,
        appid: localStorage.getItem('appId'),
        clientid: localStorage.getItem('clientId')
      }

      this.admissionsService.createNew(
        this.handlePostVerification,
        payload,
        "v1/users/verify-otp"
      );
  
    }
  }

  componentDidMount() {
    const { isInactive } = this.props.data
    if (isInactive) {
      this.getOtp()
    }
  }

  handleValidation() {
    let fields = this.state;
    let errors = {};
    let formIsValid = true;

    if (!fields["otp"]) {
      formIsValid = false;
      errors["otp"] = "Cannot be empty";
    }

    this.setState({ errors: errors });
    return formIsValid;
  }

  showSelectedId = (event) => {
    this.props.changeForm(event);
  }

  render() {
    // Show the "account being created & verified" card once done
    if (this.state.showVerificationUI) {
      return (
                   <div className="g-bg-white rounded g-pa-30 u-shadow-v33 g-max-width-500 mx-auto g-mt-50 g-brd-around g-brd-gray-light-v4 text-center">
  
                <div className="g-mb-20">
                  <span className="u-icon-v3 u-icon-size--3xl g-bg-green g-color-white g-rounded-50x">
                    <i className="fa fa-check"></i>
                  </span>
                </div>

                <h1 className="g-font-weight-600 g-font-size-20 g-color-black g-mb-10">
                  Account Verification in Progress
                </h1>
       
                <p className="g-color-gray-dark-v4 g-mb-30 g-font-size-15">
                  Your account is being created and verified.<br />
                  Our Admin will review and approve it soon.
                </p>
              
                <button
                  className="btn btn-md u-btn-primary g-font-size-14 g-px-20 g-py-10 g-rounded-4"
                  onClick={() => window.location.href = '/'}
                >
                  Go to Home
                </button>
              
              </div>
      );
    }

    // Default: OTP form
    return (
      <div className="g-bg-white rounded">
        <h1>OTP Confirmation</h1>
        <p>We have sent you an OTP on your registered mobile no and Email id.</p>
        <div className="g-mb-20">
          <div className="input-group admn-input-group">
            <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
              <i className="icon-education-166 u-line-icon-pro"></i>
            </span>
            <input
              className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12"
              type="text"
              placeholder="Enter OTP"
              name="otp"
              onChange={this.handleChange}
              disabled={this.state.isSubmitting}
            />
          </div>
          <span style={{ color: "red" }}>{this.state.errors["otp"]}</span>
          <button
            type="button"
            className='auth-link forgot-password btn btn-link p-0'
            onClick={this.getOtp}
            disabled={this.state.isSubmitting}
          >
            Resend OTP
          </button>
        </div>

        <div className="d-flex">
          <button
            type="submit"
            className="admn-btn w-100 btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-font-size-default rounded g-px-25 g-py-7 ml-auto"
            onClick={this.handleLogin}
            disabled={this.state.isSubmitting}
          >
            {this.state.isSubmitting ? 'Verifying…' : 'Verify OTP'}
          </button>
        </div>

        <div className='text-center'>
          Back to log in?{' '}
          <button
            type='button'
            className="btn btn-link p-0 auth-link"
            id="signin-link"
            onClick={(event) => this.showSelectedId(event)}
            disabled={this.state.isSubmitting}
          >
            Back
          </button>
        </div>
      </div>
    );
  }
}

export default OtpForm;




/** WEBPACK FOOTER **
 ** ./src/components/SignIn/OtpForm.js
 **/